import index from "./lmsContact.vue";
export default index;
